<template>
  <v-menu offset-y content-class="mt-2">
    <template #activator="{on, attrs}">
      <z-chip
        class="mr-1"
        v-bind="attrs"
        x-small
        :disabled="disabled"
        :color="color"
        :close="value != null"
        :selected="value != null"
        :text="text"
        :icon="icon"
        :icon-color="iconColor"
        v-on="on"
        @click:close="$emit('input', {id: id, value: null})"
      />
    </template>

    <z-card width="auto" class="pa-0">
      <template #content>
        <v-list dense nav class="px-0 py-4">
          <v-list-item-group
            :value="value"
            @change="$emit('input', {id, value: $event})"
          >
            <v-list-item
              v-for="(item, index) of configuration.items"
              :key="index"
              class="py-0 px-4 mb-0"
              :color="color"
              :value="item.value"
            >
              <v-list-item-action v-if="item.icon" class="mr-0">
                <z-icon size="16" color="black">
                  {{ item.icon }}
                </z-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </template>
    </z-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },

    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },

    value: {
      type: String,
      default: null,
    },

    color: {
      type: String,
      default: 'var(--primary)',
    },

    configuration: {
      type: Object,
      default: () => ({
        items: [],
      }),
    },
    iconColor: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
:deep(.v-chip__close) {
  font-size: 12px !important;
}

:deep(.v-list-item) {
  min-height: 24px !important;
  height: 24px !important;

  * {
    font-weight: 400 !important;
  }

  &::before {
    border-radius: 0px;
  }
}
</style>
